import React, { FC } from 'react';

import Logo from 'components/Layout/Logo';

import styles from './homeAnimation.module.scss';

interface IProps {
  lines: string[];
}

const HomeAnimation: FC<IProps> = ({
  lines,
}) => (
  <div className={styles.wrapper}>
    <Logo className={styles.logo} />
    <span className={styles.animation}>
      {lines.map((line: string) => (
        <span key={line} className={styles.animationLine}>{line}</span>
      ))}
    </span>
  </div>
);

export default HomeAnimation;
